import {SharedInitGuard} from '@shared/guards/shared-init.guard';
import { Component, OnInit, inject } from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {Storage} from "@ionic/storage-angular";
import {Store} from "@ngrx/store";
import {environment as teamEnv} from "@env-team/environment";
import {SharedLanguageService} from "@shared/services/shared-language.service";
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";
import {SharedLoginActions} from "@shared/components/login/store/shared-login.actions-type";
import {EAppType} from "@shared/models/AppType.enum";
import {filter, firstValueFrom} from "rxjs";
import {SharedLoginSelectors} from "@shared/components/login/store/shared-login.selector-type";

// Init the CoreEnvironmentService with the TEAM app environment variables
CoreEnvironmentService.setEnvironment(teamEnv);

@Component({
  selector: 'app-root',
  templateUrl: 'team-app.component.html',
  styleUrls: ['team-app.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class TeamAppComponent implements OnInit {
  private _storage = inject(Storage);
  private _store = inject(Store);
  private _languageService = inject(SharedLanguageService);



  constructor() {
    inject(SharedInitGuard);
    // Set app type
    this._store.dispatch(SharedLoginActions.setAppType({ appType: EAppType.Team }));
    // Get the default language
    const environment = CoreEnvironmentService.getEnvironment();
    this._languageService.setDefaultLanguageByEnvironment(environment);
  }

  async ngOnInit() {
    await this._storage.create();
    await firstValueFrom(this._store.select(SharedLoginSelectors.selectAppType).pipe(filter(appType => appType !== undefined) ));
  }
}
